import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["details"];

  toggle({ params: { id } }) {
    this.detailsTargets
      .filter((row) => row.dataset.rowDetailsId === String(id))
      .forEach((row) => { row.hidden = !row.hidden; });
  }
}
